// extracted by mini-css-extract-plugin
export default {"iconWrapper":"icon-wrapper--lWdGKTK3BMqAF93n4zBd"};